import { LocalizedAsset } from '@warema/shared/models';

export class LocalizedAssetUtilities {
    public static getLocalizedAsset<T>(asset: LocalizedAsset<T>, language: string): T | undefined {
        if (language.length > 2) {
            // handle differences between configurator (en) and plus (en-GB)
            language = language.slice(0, 2);
        }

        if (asset == null || language == null || asset[language] == null) {
            return undefined;
        }

        return asset[language];
    }
}
